import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";

// Redux
import { GetCategory, saveCategory } from "./index";

// Api's
import { categoryApi } from "../../api";
import { CategoryResponse } from "@/main/models/response";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getCategorySaga(action: GetCategory) {
	try {
		const response: AxiosResponse<Result<CategoryResponse[]>> = yield call(
			categoryApi.getDomain,
			action.payload.isCanastaBasica,
		);

		if (response.data.result) {
			yield put(saveCategory(response.data.result, false, null));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveCategory(null, true, resultError.messagesDataError));
		}
	}
}
